import OrderedTicket, {
    OrderedTicketItem,
} from 'components/shared/OrderedTicket'
import { useState } from 'react'
import { useSelfcare } from 'store/selfcare-slice/hooks'
import { SpaReservation } from 'store/selfcare-slice/types'
import moment from 'moment'

interface SpaTicketProps {
    spa: SpaReservation
    index: number
}

export interface InitialData {
    unitPrice?: number
    productId?: string
}

export type ChangesDataAttr = {
    date?: string
}

const SpaTicket = ({ spa, index }: SpaTicketProps) => {
    const { deleteItem, revertDeleteItem } = useSelfcare()

    const { original, changeType, changes, isActive, modificationId } = spa
    const [isActionErrors, setIsActionErrors] = useState(false)

    const {
        detail: { orderSpaTreatmentId, startDate },
        price,
        name,
    } = changes || original

    const handleDelete = () => {
        if (!orderSpaTreatmentId) return

        setIsActionErrors(false)
        deleteItem({
            productType: 'spa_treatment',
            detail: { orderSpaTreatmentId },
        }).then(({ isSuccess }) => {
            if (!isSuccess) setIsActionErrors(true)
        })
    }

    const handleRevert = () => {
        if (!modificationId) return

        revertDeleteItem(modificationId)
    }

    const spaItem: OrderedTicketItem[] = [
        {
            text: name,
            date: startDate && moment(startDate).format('ddd DD.MM, HH:mm'),
        },
    ]

    return (
        <OrderedTicket
            items={spaItem}
            price={price || 0}
            onDelete={handleDelete}
            onRevert={handleRevert}
            withEditEnabled={false}
            isDeleted={isActive && changeType === 'return'}
            isDisabled={!isActive}
            isActionError={isActionErrors}
            id={`spa-${orderSpaTreatmentId}`}
            testIdPrefix={`selfcare-spa-${index}`}
        />
    )
}
export default SpaTicket
